import { alpha, Box, Portal, Typography } from "@mui/material";
import { FONT_DISPLAY, lightTheme } from "@asi/design-tokens";
import Flash14StarMark from "features/decisionPoint/components/fusionAperture/lab/variants/flash14/StarMark";
import { flash14Motion } from "features/decisionPoint/components/fusionAperture/lab/variants/flash14/motion";
import { TEST_IDS } from "shared/utils/utils/testIds";
import "./fusionMsiWaitOverlay.css";

const { xs, sm, md } = flash14Motion.introSize;

/**
 * Full-viewport FusionMSI mark shown above the page while a process is in flight.
 * Used by Loading when page is set.
 */
export default function FusionMsiWaitOverlay() {
  return (
    <Portal>
      <Box
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label="Fusion In Progress"
        data-testid={TEST_IDS.common.loadingOverlay}
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: (theme) => theme.zIndex.modal,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: (theme) => alpha(theme.palette.common.black, 0.72),
          backdropFilter: "blur(12px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ width: { xs: xs + 72, sm: sm + 140, md: md + 200 }, overflow: "visible" }} aria-hidden="true">
            <Flash14StarMark wait />
          </Box>
          <Typography
            variant="h5"
            component="p"
            sx={{
              fontFamily: FONT_DISPLAY,
              color: lightTheme.colors.primary,
              m: 0,
            }}
          >
            Fusion In Progress
          </Typography>
        </Box>
      </Box>
    </Portal>
  );
}
